"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FINGERPRINT = exports.TOKEN = exports.Versions = exports.Endpoints = exports.QueryKeys = void 0;
var QueryKeys;
exports.QueryKeys = QueryKeys;

(function (QueryKeys) {
  QueryKeys["Account"] = "Account";
  QueryKeys["OrderHistory"] = "OrderHistory";
  QueryKeys["ResendVerificationEmail"] = "ResendVerificationEmail";
  QueryKeys["PreviousOrder"] = "PreviousOrder";
})(QueryKeys || (exports.QueryKeys = QueryKeys = {}));

var Endpoints;
exports.Endpoints = Endpoints;

(function (Endpoints) {
  Endpoints["Account"] = "account";
  Endpoints["ChangePassword"] = "account/changePassword";
  Endpoints["CreateAccount"] = "account/v2/create";
  Endpoints["DeleteAccount"] = "account";
  Endpoints["ForgotPassword"] = "account/forgotPassword";
  Endpoints["Login"] = "account/v2/login";
  Endpoints["OrderHistory"] = "account/orderHistory";
  Endpoints["PreviousOrder"] = "account/previousorder";
  Endpoints["ResendVerificationEmail"] = "account/ResendVerificationEmail";
  Endpoints["UpdateAccount"] = "account/update";
})(Endpoints || (exports.Endpoints = Endpoints = {}));

var Versions;
exports.Versions = Versions;

(function (Versions) {
  Versions["Account"] = "v1";
  Versions["ResendVerificationEmail"] = "v1";
})(Versions || (exports.Versions = Versions = {}));

var TOKEN = '@lce/local/token';
exports.TOKEN = TOKEN;
var FINGERPRINT = '@lce/local/uuid';
exports.FINGERPRINT = FINGERPRINT;